import { ref } from 'vue';
import { useAppConfigStore } from '@/stores/appConfigStore';
import router from '@/router';

const isRedirecting = ref(false);

export function useAuthHelper() {
  async function redirectToAuth(returnUrl?: string) {
    if (isRedirecting.value) {
      console.log('Already being redirected');
      return;
    }
    isRedirecting.value = true;
    const appConfigStore = useAppConfigStore();
    const signInUrl = appConfigStore.appConfig.signInUrl;
    if (signInUrl == null) {
      return;
    }

    const actualReturnUrl = returnUrl ?? router.resolve(router.currentRoute.value).href;
    const absoluteReturnURL = new URL(actualReturnUrl, window.location.origin).href;
    window.location.href = signInUrl.replace('{0}', absoluteReturnURL);
  }

  return {
    redirectToAuth
  };
}
